/// <amd-module name="Test/AssociateToTestCase/Actions/AssociateToTestCaseActionHub" />
import * as TCMContracts from "Test/common-util/Contracts/Test";
import { Action } from "VSS/Reflux/Action";
import { WorkItem } from 'Wit/Clients/Wit/Contracts/WorkItemTracking';

export interface ITestCaseResultHolder {
    testCaseResult: TCMContracts.TestCaseResult;
    workItems: WorkItem[];
    fullyQualifiedName: string;
}

export class AssociateToTestCaseActionHub {
    public onDismiss = new Action<void>();
    public onError = new Action<string>();
    public associateToTestCaseDialog = new Action<ITestCaseResultHolder>();
    public addAssociateTestCase = new Action<WorkItem>();
    public addAssociateTestCaseFailure = new Action<string>();
}